import { merge } from 'lodash';
import brickxTheme from 'src/themes/brickx/brickxTheme';
import {
  lavender,
  purpleLight,
  yellow50,
  yolk,
  primary,
  lightBackgroundPrimary,
  onDarkSurfacePrimary,
  blue50,
  blue500,
  blue800,
  green,
  greenDark,
  greenLight,
  purple,
  purple100,
} from './brickx/colors';

export const themeForBrickXMinorLandingPage = merge({}, brickxTheme, {
  colors: {
    primary: yolk,
    lightBackgroundPrimary: yellow50,
    onDarkSurfacePrimary: '#FAC800',
  },
});

export const themeForBrickXAvenue = merge({}, brickxTheme, {
  colors: {
    primary: purple,
    lightBackgroundPrimary: purpleLight,
    onDarkSurfacePrimary: lavender,
  },
});

export const themeForBrickXWholesale = merge({}, brickxTheme, {
  colors: {
    primary: blue500,
    lightBackgroundPrimary: blue50,
    onDarkSurfacePrimary: blue500,
  },
});

export const themeForBrickXPrivateSyndicate = merge({}, brickxTheme, {
  colors: {
    primary: blue800,
    lightBackgroundPrimary: blue50,
    onDarkSurfacePrimary: blue800,
  },
});

export const themeForBrickXMortgage = merge({}, brickxTheme, {
  colors: {
    primary: greenDark,
    lightBackgroundPrimary: greenLight,
    onDarkSurfacePrimary: green,
  },
});

export const themeForSmsfAccount = merge({}, brickxTheme, {
  colors: {
    primary: blue500,
    lightBackgroundPrimary: blue50,
    onDarkSurfacePrimary: blue500,
  },
});

export const themeForAdvisorAccount = merge({}, brickxTheme, {
  colors: {
    primary: purple,
    lightBackgroundPrimary: purple100,
    onDarkSurfacePrimary: purple,
  },
});

export const themeForIndividualAccount = merge({}, brickxTheme, {
  colors: {
    primary,
    lightBackgroundPrimary,
    onDarkSurfacePrimary,
  },
});
